"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Portal_1 = __importDefault(require("~/components/UI/Portal"));
const utils_1 = require("~/utils/utils");
const events_1 = require("~/consts/events");
const Notification_1 = __importDefault(require("./Notification"));
const NotificationsManager_scss_1 = __importDefault(require("./NotificationsManager.scss"));
function NotificationsManager() {
    const [notifications, setNotifications] = (0, react_1.useState)([]);
    const enqueueNotification = (notification) => {
        setNotifications((current) => [...current, notification]);
    };
    const showNotification = (e) => {
        const id = (0, utils_1.generateUniqueLikeString)();
        const notification = Object.assign(Object.assign({}, e.detail), { id });
        enqueueNotification(notification);
    };
    const onNotificationDestroy = (id) => {
        setNotifications((current) => current.filter((notification) => notification.id !== id));
    };
    (0, react_1.useEffect)(() => {
        document.body.addEventListener(events_1.dispatchNotification, showNotification);
        return () => {
            document.body.removeEventListener(events_1.dispatchNotification, showNotification);
        };
    }, []);
    return notifications.length > 0 ? (react_1.default.createElement(Portal_1.default, null,
        react_1.default.createElement("div", { className: NotificationsManager_scss_1.default.manager }, notifications.slice(0, 3).map((notification) => {
            return (react_1.default.createElement(Notification_1.default, { key: notification.id, id: notification.id, message: notification.message, type: notification.type, timeout: notification.timeout, onDestroy: onNotificationDestroy }));
        })))) : null;
}
exports.default = NotificationsManager;
